var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showForm)?_c('age-confirmation-form',{attrs:{"birth-date":_vm.dateOfBirth},on:{"submit":_vm.submitAge}}):(_vm.showDeclined)?_c('age-confirmation-declined'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }